import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import trueprofit from "../../Assets/Projects/trueprofit.png";
import haravan from "../../Assets/Projects/haravan.png";
import nailzy from "../../Assets/Projects/nailzy.png";
import forecastrx from "../../Assets/Projects/forecastRx.png";
import trading from "../../Assets/Projects/trading.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={trueprofit}
              isHomePage={true}
              homePageLink="https://app.trueprofit.io"
              title="True Profit"
              description="An application is designed to track revenue, calculate profit, and provide insights into orders, products, and campaigns. Built with Microservices, AWS, Golang, MongoDB, Elasticsearch, and Node.js."
              demoLink="https://app.trueprofit.io/demo"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={haravan}
              isHomePage={true}
              homePageLink="https://www.haravan.com/"
              title="Haravan"
              description="An Omni-channel be integrated with other E-commerce platforms, designed to centralize and management flow of order, product, inventory, customer,... Built with NestJS, Golang, MongoDB, RabbitMQ,..."
              demoLink="https://www.haravan.com/" 
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={nailzy}
              isHomePage={true}
              homePageLink="https://www.nailzy.com/"
              title="Nailzy"
              description="An E-commerce platform be designed to connect and exchange seamlessly with merchants and buyers. Built with ExpressJS, React, MongoDB, RabbitMQ..."
              demoLink="https://nailzy.com/en"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={forecastrx}
              isHomePage={true}
              homePageLink="https://inventoryoptimizer.ai/"
              title="ForecastRx"
              description="An application that uses advanced analytics to provide real-time inventory, warehouse capacity, and warehouse usage information and insights. Built with NodeJS, MongoDB, RabbitMQ..."
              demoLink="https://demo.inventoryoptimizer.ai/demo/cma728eqr0001zs0imqsxx7zi"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={trading}
              isHomePage={false}
              homePageLink="https://github.com/Natsu-Development/bot-trade-stock"
              title="VN Trading Terminal"
              description="An automated trading bot designed for the Vietnamese stock market. It performs time-range technical analysis, specifically detecting RSI divergences, trendline breakouts and advanced filters."
              demoLink="https://zionle.io.vn/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
